import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/notifications" });

export interface NotificationListFilters {
  page?: number;
  limit?: number;
}

export const NotificationService = {
  getNotifications: (filters: NotificationListFilters = {}) => {
    const params = buildQueryParams(filters);
    const query = params.toString();
    return api.get(query ? `?${query}` : "");
  },

  markAsRead: (id: number | string) => {
    return api.patch(`/${id}/read`, {});
  },

  markAllAsRead: () => {
    return api.patch("/read-all", {});
  },

  registerDevice: (token: string) => {
    return api.post("/register-device", { token, platform: "web" });
  },

  unregisterDevice: (token: string) => {
    return api.delete(`/unregister-device/${token}`);
  },
};
